import React, { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import { Modal, Input, Row, Col, FormGroup, Label } from "reactstrap"
import {
  AvField,
  AvForm,
  AvRadioGroup,
  AvRadio,
  AvInput,
} from "availity-reactstrap-validation"
import {
  getLessons,
  addQuestion,
  editQuestion,
  addQuestionClean,
  editQuestionClean,
  editAnswer,
  removeAnswer,
  removeQuestion,
  addAnsswers,
} from "store/actions"
import ImageUploadModal from "components/Common/ImageUploadModal"
import {
  DeleteBlankAnswerButton,
  isBlankAnswer,
} from "./blankAnswer"

const MultiQuestionModal = props => {
  const idQuestionType = 1
  const dispatch = useDispatch()
  const [formError, setFormError] = useState(false)
  const [showImageUploadModal, setShowImageUploadModal] = useState(false)
  const [image, setImage] = useState("")
  const [value, setValue] = useState(null)
  const [questionName, setQuestionName] = useState("")
  const [answer1, setAnswer1] = useState(undefined)
  const [answer2, setAnswer2] = useState(undefined)
  const [answer3, setAnswer3] = useState(undefined)
  const [answer4, setAnswer4] = useState(undefined)

  const isDraft = props.isDraft === true

  const idQuestion =
    props.question !== undefined ? props.question.idQuestion : 0

  const {
    lessons,
    questionAddLoading,
    questionAddDone,
    questionAddError,
    answersAddLoading,
    questionEditLoading,
    questionEditDone,
    questionEditError,
  } = useSelector(store => ({
    lessons: store.LessonsList.lessons,
    questionAddLoading: store.QuestionAdd.loading,
    questionAddDone: store.QuestionAdd.done,
    questionAddError: store.QuestionAdd.error,
    answersAddLoading: store.AnswersAdd.loading,
    questionEditLoading: store.QuestionEdit.loading,
    questionEditDone: store.QuestionEdit.done,
    questionEditError: store.QuestionEdit.error,
  }))

  useEffect(() => {
    dispatch(getLessons(props.course.courseId))
    setQuestionName(props.question !== undefined ? props.question.question : "")
    setImage(props.question !== undefined ? props.question.image : "")
    return () => {
      setValue(null)
      setFormError(false)
    }
  }, [props.question])

  useEffect(() => {
    if (!props.show) {
      return
    }
    const questionAnswers =
      props.question !== undefined && Array.isArray(props.question.answers)
        ? props.question.answers
        : []
    if (questionAnswers.length > 0) {
      const correct = questionAnswers.find(answer => answer.correctAnswer === 1)
      setValue(questionAnswers.indexOf(correct) + 1)
      setAnswer1(questionAnswers[0])
      setAnswer2(questionAnswers[1])
      setAnswer3(questionAnswers[2])
      setAnswer4(questionAnswers[3])
    } else {
      setValue(1)
      setAnswer1(undefined)
      setAnswer2(undefined)
      setAnswer3(undefined)
      setAnswer4(undefined)
    }
  }, [idQuestion, props.show])

  const deleteBlankAnswer = (answer, setter) => {
    if (!answer?.idQuestionAnswer || !isBlankAnswer(answer)) return
    dispatch(removeAnswer(answer.idQuestionAnswer))
    setter(undefined)
  }

  const handleSubmit = async (event, errors, values) => {
    if (errors.length > 0) {
      setFormError(true)
      return
    }
    setFormError(false)

    const buildAnswers = () =>
      [answer1, answer2, answer3, answer4]
        .map((answer, index) => ({
          answer: String(answer?.answer ?? "").trim(),
          image: "",
          correctAnswer: parseInt(value) === index + 1 ? 1 : 0,
        }))
        .filter(item => item.answer !== "")

    const request = {
      courseExam: props.exam.idCourseExam,
      idQuestionType: idQuestionType,
      idLessonRef: parseInt(values.idLessonRef),
      question: values.question,
      image: image,
    }

    if (isDraft) {
      props.onDraftSave(request, buildAnswers())
      return
    }

    if (props.question === undefined) {
      dispatch(addQuestion(request))
    } else {
      request.idExamQuestion = props.question.idQuestion
      dispatch(editQuestion(request))

      if (!(props.question.answers.length > 0)) {
        const answers = buildAnswers()
        if (answers.length > 0) {
          dispatch(
            addAnsswers({
              idExamQuestion: props.question.idQuestion,
              List: answers,
            })
          )
        }
      } else {
        const slots = [answer1, answer2, answer3, answer4]
        slots.forEach((answer, index) => {
          if (!answer?.idQuestionAnswer || isBlankAnswer(answer)) return
          dispatch(
            editAnswer({
              idQuestionAnswer: answer.idQuestionAnswer,
              idExamQuestion: answer.idQuestion,
              answer: String(answer.answer).trim(),
              image: "",
              correctAnswer: parseInt(value) === index + 1 ? 1 : 0,
            })
          )
        })
      }
    }
  }

  if (questionAddDone && !isDraft) {
    dispatch(addQuestionClean())
    props.onConfirm()
  }

  if (questionEditDone) {
    dispatch(editQuestionClean())
    props.onConfirm()
  }

  return (
    <Modal isOpen={props.show} backdrop={"static"} id="staticBackdrop">
      <AvForm className="form-horizontal" onSubmit={handleSubmit}>
        <div className="modal-header">
          <h5 className="modal-title" id="staticBackdropLabel">
            Pregunta: Opción múltiple
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={() => {
              if (!isDraft && questionName === "" && idQuestion !== 0) {
                dispatch(removeQuestion(idQuestion))
              }
              props.onCancel()
            }}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          {formError && (
            <div className="alert alert-danger">
              Existen errores en el formulario. Por favor corrígelos para
              continuar.
            </div>
          )}
          {questionAddError !== "" && (
            <div className="alert alert-danger">{questionAddError}</div>
          )}
          <Row className="mb-4">
            <Col md={12}>
              <AvField
                name="question"
                label="Ingresa la pregunta"
                className="form-control"
                placeholder="Ingresar"
                value={
                  props.question !== undefined ? props.question.question : ""
                }
                type="text"
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Este campo es requerido",
                  },
                }}
              />
            </Col>
          </Row>
          <Row className="mb-4">
            <Col>
              <a
                href={image}
                target={"_blank"}
                className={`btn btn-light btn-block ${
                  image !== "" ? "" : "disabled"
                }`}
                rel="noreferrer"
              >
                <i className="fa fa-image"></i> Ver imagen cargada
              </a>
            </Col>
            <Col>
              {image !== "" ? (
                <button
                  onClick={() => setShowImageUploadModal(true)}
                  type="button"
                  className="btn btn-light btn-block"
                >
                  <i className="fa fa-undo"></i> Cambiar imagen
                </button>
              ) : (
                <button
                  onClick={() => setShowImageUploadModal(true)}
                  type="button"
                  className="btn btn-light btn-block"
                >
                  <i className="fa fa-plus-circle"></i> Agregar imagen
                </button>
              )}
            </Col>
          </Row>
          <Row className="mb-4">
            <Col md={1}>
              <AvRadioGroup
                name="private"
                className="form-control noNorder"
                onChange={e => setValue(parseInt(e.target.value))}
                value={value}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Seleccione la respuesta correcta",
                  },
                }}
              >
                <div className="mb-4">
                  <AvRadio value={1} />
                </div>
                <div className="mb-4">
                  <AvRadio value={2} />
                </div>
                <div className="mb-4">
                  <AvRadio value={3} />
                </div>
                <div className="">
                  <AvRadio value={4} />
                </div>
              </AvRadioGroup>
            </Col>
            <Col md={11}>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="answer1"
                    className="form-control"
                    placeholder="Ingresa la respuesta 1"
                    value={answer1 === undefined ? "" : answer1.answer}
                    onChange={e =>
                      setAnswer1({ ...answer1, answer: e.target.value })
                    }
                    type="text"
                  />
                  {answer1?.idQuestionAnswer && isBlankAnswer(answer1) && (
                    <DeleteBlankAnswerButton
                      onDelete={() => deleteBlankAnswer(answer1, setAnswer1)}
                    />
                  )}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="answer2"
                    className="form-control"
                    placeholder="Ingresa la respuesta 2"
                    value={answer2 === undefined ? "" : answer2.answer}
                    onChange={e =>
                      setAnswer2({ ...answer2, answer: e.target.value })
                    }
                    type="text"
                  />
                  {answer2?.idQuestionAnswer && isBlankAnswer(answer2) && (
                    <DeleteBlankAnswerButton
                      onDelete={() => deleteBlankAnswer(answer2, setAnswer2)}
                    />
                  )}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="answer3"
                    className="form-control"
                    placeholder="Ingresa la respuesta 3"
                    value={answer3 === undefined ? "" : answer3.answer}
                    onChange={e =>
                      setAnswer3({ ...answer3, answer: e.target.value })
                    }
                    type="text"
                  />
                  {answer3?.idQuestionAnswer && isBlankAnswer(answer3) && (
                    <DeleteBlankAnswerButton
                      onDelete={() => deleteBlankAnswer(answer3, setAnswer3)}
                    />
                  )}
                </Col>
              </Row>
              <Row className="mb-2">
                <Col xs={12} className="d-flex align-items-center">
                  <AvInput
                    name="answer4"
                    className="form-control"
                    placeholder="Ingresa la respuesta 4"
                    value={answer4 === undefined ? "" : answer4.answer}
                    onChange={e =>
                      setAnswer4({ ...answer4, answer: e.target.value })
                    }
                    type="text"
                  />
                  {answer4?.idQuestionAnswer && isBlankAnswer(answer4) && (
                    <DeleteBlankAnswerButton
                      onDelete={() => deleteBlankAnswer(answer4, setAnswer4)}
                    />
                  )}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <AvField
                name="idLessonRef"
                label="Referencia a una lección"
                className="form-control"
                placeholder=""
                type="select"
                value={
                  props.question !== undefined
                    ? props.question.idLessonReference
                    : ""
                }
                validate={{}}
              >
                <option value="">Sin referencia</option>
                {lessons.length > 0 &&
                  lessons.map(lesson => (
                    <option key={lesson.idLesson} value={lesson.idLesson}>
                      {lesson.title}
                    </option>
                  ))}
              </AvField>
            </Col>
          </Row>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-light"
            onClick={() => {
              if (!isDraft && questionName === "" && idQuestion !== 0) {
                dispatch(removeQuestion(idQuestion))
              }
              props.onCancel()
            }}
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={isDraft && (questionAddLoading || answersAddLoading)}
            className={`btn btn-secondary ${
              questionAddLoading || questionEditLoading || (isDraft && answersAddLoading)
                ? "disabled"
                : ""
            }`}
          >
            {questionAddLoading || questionEditLoading || (isDraft && answersAddLoading)
              ? "Guardando..."
              : "Guardar"}
          </button>
        </div>
      </AvForm>
      <style jsx="true">{`
        .noNorder {
          border: 0 !important;
        }
      `}</style>
      {showImageUploadModal && (
        <ImageUploadModal
          key={"true-false-question-modal"}
          onConfirm={image => {
            setImage(image)
            setShowImageUploadModal(false)
          }}
          onCancel={() => setShowImageUploadModal(false)}
          show={true}
        />
      )}
    </Modal>
  )
}

MultiQuestionModal.propTypes = {
  show: PropTypes.bool,
  question: PropTypes.object,
  isDraft: PropTypes.bool,
  exam: PropTypes.object,
  course: PropTypes.object,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  onDraftSave: PropTypes.func,
}

export default MultiQuestionModal
